import React from "react";
import styled from "styled-components";
// Components

import ServiceBox from "components/ServiceBox";
import Analytics from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/assets/svg/Analytics.jsx"
import { Button } from "components/Button";
// Assets
import AddImage1 from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/components/Img/add/1.png";
import AddImage2 from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/components/Img/add/2.png";
import AddImage3 from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/components/Img/add/3.png";
import AddImage4 from "/Users/pandora/Code/Web/shopeg-d2ctrust-web/src/components/Img/add/4.png";
import FullButton from "components/Button/FullButton";

export default function Services() {

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  return (
    <Wrapper id="services">
      
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        
        <div className="container">
          
          <HeaderInfo style={{ paddingBottom: "40px" }}>
            <h1 className="font40 extraBold">Benefits</h1>
            <p className="font22">
            Scale your offline channel seemlessly through trusted local stores.
            </p>
          </HeaderInfo>

        
          <Wrapper className="flexCenter">
               
          <Analytics />
              </Wrapper>
          <ServiceBoxRow className="flex">
            
            <ServiceBoxWrapper>
              <ServiceBox
                icon="roller"
                title="Real time data"
                subtitle="From referrals to signups. Track the complete lifecycle."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="monitor"
                title="Increased sales"
                subtitle="Connect with new customers offline"/>
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Low CAC"
                subtitle="Predictable and low cost of distribution with high output "
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="printer" title="Targetted referrals" subtitle="Choose specific areas for referral" />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
          {/* <ServiceBoxRow className="flex">
          <ServiceBoxWrapper>
              <ServiceBox
                icon="browser"
                title="Low CAC"
                subtitle="Predictable and low cost of distribution with high output "
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox icon="printer" title="Targetted referrals" subtitle="Choose specific areas for referral" />
            </ServiceBoxWrapper>
          </ServiceBoxRow> */}
          
        </div>
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                {/* <h4 className="font15 semiBold">A few words about company</h4> */}
                <h2 className="font40 extraBold">Ready to scale?</h2>
                <p className="font18">
                Scale your D2C brand via trusted offline retail sellers
                </p>
                <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0"}}>
                  <div style={{ width: "190px" }}>
                    <Button title="Scale Now" onClick={()=>openInNewTab('https://forms.gle/cX5TH1xp498ia6gx7')}>Scale Now</Button>
                  </div>
                  {/* <div style={{ width: "190px", marginLeft: "15px" }}>
                    <FullButton title="Contact Us" action={() => alert("clicked")} border />
                  </div> */}
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                    <img className="radius8" src="images/img_shop4.jpg" alt="office" style={{zIndex: 8, width:"300px"}}/>
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                    <img className="radius8" src="images/img_shop2.jpg" alt="office" style={{zIndex: 8}} />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                    <img className="radius8" src="images/img_shop1.jpg" alt="office" style={{zIndex: 8}} />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                    <img className="radius8" src="images/img_shop3.jpg" alt="office" style={{zIndex: 8}} />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`

  @media (max-width: 860px) {
    justify-content: space-around;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;